import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const GetEDispatch = (params: any) =>
  request({
    url: ApiURL.Query.GetEDispatch,
    method: RequestType.GET,
    params: params,
    responseType: "blob",
  });

const GetEArchiveEInvoice = (params: any) =>
  request({
    url: ApiURL.Query.GetEArchiveEInvoice,
    method: RequestType.GET,
    params: params,
  });

const BillingQuery = {
  GetEDispatch,
  GetEArchiveEInvoice,
};

export default BillingQuery;
